import { coloreUtente } from "@/pages/crm/crmComuni";
import { righeValide, isDev } from "@/lib/ambito";

// Sprint CRM-2B — date e ore sempre in ora italiana (Europe/Rome), qualunque sia il fuso del browser
const PARTI = new Intl.DateTimeFormat("it-IT", { timeZone: "Europe/Rome", year: "numeric", month: "2-digit", day: "2-digit",
  hour: "2-digit", minute: "2-digit", hourCycle: "h23" });
export function partiRoma(iso) {
  const p = Object.fromEntries(PARTI.formatToParts(new Date(iso)).map((x) => [x.type, x.value]));
  return { y: +p.year, m: +p.month, d: +p.day, h: +p.hour, mi: +p.minute };
}
// Per la libreria: un Date «locale» con l'ora italiana scritta sopra (così ciò che si vede è l'ora italiana)
export const dataPerVista = (iso) => { const p = partiRoma(iso); return new Date(p.y, p.m - 1, p.d, p.h, p.mi); };
const due = (n) => String(n).padStart(2, "0");
// Valore per <input type="datetime-local">: si manda così al server, che lo legge come ora italiana
export const perInput = (iso) => { if (!iso) return ""; const p = partiRoma(iso); return `${p.y}-${due(p.m)}-${due(p.d)}T${due(p.h)}:${due(p.mi)}`; };
export const daVista = (d) => `${d.getFullYear()}-${due(d.getMonth() + 1)}-${due(d.getDate())}T${due(d.getHours())}:${due(d.getMinutes())}`;
export const fmtEvento = (ev) => {
  const p = partiRoma(ev.inizio);
  return `${due(p.d)}/${due(p.m)}/${p.y}${ev.tutto_il_giorno ? "" : ` ${due(p.h)}:${due(p.mi)}`}`;
};
export const oggiRoma = () => { const p = partiRoma(new Date().toISOString()); return `${p.y}-${due(p.m)}-${due(p.d)}`; };
export const giornoRoma = (iso) => perInput(iso).slice(0, 10);

// Colore: personali con il colore fisso dell'utente (stessa funzione del pallino CRM); di sede un colore per sede
export const coloreEvento = (ev) => coloreUtente(ev.calendario === "sede" ? `sede:${ev.site_id}` : ev.proprietario_id);
export const TIPI_EVENTO = { appuntamento: "Appuntamento", chiamata: "Chiamata", promemoria: "Promemoria" };

// Lista: scadute e di oggi (non fatte) in evidenza in alto, poi le prossime
export const evidenza = (ev, oggi = oggiRoma()) => !ev.fatto && giornoRoma(ev.inizio) <= oggi;
export function ordinaLista(eventi, oggi = oggiRoma()) {
  const sopra = eventi.filter((e) => evidenza(e, oggi));
  return [...sopra, ...eventi.filter((e) => !sopra.includes(e))];
}


// Calendari in cui si può creare: il mio (per azienda), le sedi visibili, i colleghi (solo con la casella)
export function scelteNuovo(cal, user) {
  const aziende = [...new Set(isDev(user) ? cal.sedi.map((s) => s.company_id) : righeValide(user).map((r) => r.company_id))];
  return [
    ...aziende.map((cid, i) => ({ chiave: `mio:${cid}`, etichetta: aziende.length > 1 ? `Il mio calendario (${i + 1})` : "Il mio calendario",
      calendario: "personale", company_id: cid })),
    ...cal.sedi.map((s) => ({ chiave: `sede:${s.site_id}:${s.company_id}`, etichetta: `Sede ${s.nome}`, calendario: "sede", company_id: s.company_id, site_id: s.site_id })),
    ...cal.colleghi.flatMap((u) => u.aziende.map((cid) => ({ chiave: `utente:${u.id}:${cid}`, etichetta: u.nome, calendario: "personale",
      company_id: cid, proprietario_id: u.id }))),
  ];
}


// Sprint CRM-5 — il periodo mostrato, sempre visibile in alto (nomi italiani scritti qui: niente dipendenze in più)
const MESI = ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"];
const GIORNI = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
const maiuscola = (t) => t.charAt(0).toUpperCase() + t.slice(1);
const breve = (d, anno) => `${d.getDate()} ${MESI[d.getMonth()].slice(0, 3)}${anno ? ` ${d.getFullYear()}` : ""}`;
export function titoloPeriodo(vista, d) {
  if (vista === "month") return maiuscola(`${MESI[d.getMonth()]} ${d.getFullYear()}`);
  if (vista === "day") return maiuscola(`${GIORNI[d.getDay()]} ${d.getDate()} ${MESI[d.getMonth()]} ${d.getFullYear()}`);
  if (vista === "week") {
    const a = new Date(d.getFullYear(), d.getMonth(), d.getDate() - ((d.getDay() + 6) % 7));
    const b = new Date(a.getFullYear(), a.getMonth(), a.getDate() + 6);
    return `${breve(a, a.getFullYear() !== b.getFullYear())} – ${breve(b, true)}`;
  }
  return "Elenco degli eventi";
}
